// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"f8655131","89":"4951fdbe","482":"c0c9af02","648":"8b6daf44","668":"ee151f8b","723":"0112326d","734":"74aa8dc0","886":"ebef1577","905":"b989e8ab","949":"455b4c4d","962":"413d7e8a","989":"025cab69"}[chunkId] + ".chunk.js";
};